<div class="page-wrapper">
  <div>
    <app-header></app-header>
  </div>
  
  <app-main-body-view></app-main-body-view>

  <div class="content-wrapper">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  
  <div class="sticky-footer no-print">
    <app-footer></app-footer>
  </div>
  <span id="userName">{{userName.firstName}} {{userName.lastName}}</span>
  <span id="userEmail">{{userEmail.emailAddress ? userEmail.emailAddress : userEmail.mail}}</span>
  <span id="userType">{{userType.userType}}</span>
</div>
